module.exports = __webpack_public_path__ + "img/bowser-jr-min.7766232b.png";